import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-enroll-index',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="enroll-wrap">
      <div class="card">
        <h2 class="title">Bienvenido</h2>
        <p class="desc">Ingresa si ya tienes cuenta, o crea una para comenzar.</p>
        <div class="actions">
          <button class="btn primary" (click)="login()">Ingresar</button>
          <button class="btn" *ngIf="enableEnroll" (click)="signup()">Crear cuenta</button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
    .enroll-wrap{display:flex;align-items:center;justify-content:center;min-height:70vh;padding:24px}
    .card{max-width:520px;width:100%;background:#fff;border-radius:12px;box-shadow:0 6px 16px rgba(0,0,0,.08);padding:24px;}
    .title{margin:0 0 8px 0;font-size:22px;font-weight:600}
    .desc{margin:0 0 16px 0;color:#6b7280;font-size:14px}
    .actions{display:flex;gap:12px}
    .btn{appearance:none;border:none;border-radius:8px;padding:10px 16px;background:#f3f4f6;color:#111827;font-weight:500;cursor:pointer}
    .btn.primary{background:#f26600;color:#fff}
    .btn:hover{filter:brightness(.98)}
    `
  ]
})
export class EnrollIndexComponent implements OnInit {
  enableEnroll = true;

  constructor(private kc: KeycloakService, private router: Router, private config: ConfigService) {}

  async ngOnInit() {
    // Si ya está autenticado, llevar directo al admin
    try {
      this.enableEnroll = this.config.enableEnrollFlow;
      const logged = await this.kc.isLoggedIn();
      if (logged) {
        this.router.navigateByUrl('/admin');
      }
    } catch {}
  }

  async login() {
    // Usar el formulario de login propio
    await this.router.navigateByUrl('/login');
  }

  async signup() {
    if (!this.enableEnroll) {
      return;
    }
    // Ir al nuevo formulario de enrolamiento público
    this.router.navigateByUrl('/enroll');
    // Alternativa: registro directo en Keycloak si está habilitado
    // try { await this.kc.register({ redirectUri: window.location.origin + '/admin' }); } catch {}
  }
}